import React, { useRef } from "react";
import styles from "./input.module.scss";
import Image, { type StaticImageData } from "next/image";
import { NumericFormat, type NumericFormatProps } from "react-number-format";

type Props = {
  icon: StaticImageData;
  value: string | undefined;
  label: string;
  hideMinMax?: boolean;
  setValue: (value: string) => void;
  handleMin: () => void;
  handleMax: () => void;
  maxDecimal?: number;
} & NumericFormatProps;

const DispenserInput = ({
  icon,
  value,
  label,
  hideMinMax = false,
  maxDecimal = 8,
  maxLength = 8,
  handleMin,
  handleMax,
  setValue,
  ...numericFormatterProps
}: Props) => {
  const ref = useRef<HTMLInputElement>(null);

  console.log(maxLength)

  const handleClick = () => {
    ref.current?.focus();
  };

  const minMaxBtnClick = (e: React.MouseEvent, direction: () => void) => {
    // Stop propagation to parents onClick
    e.stopPropagation();
    direction();
  };

  return (
    <div className={styles.input} onClick={handleClick}>
      <div className={styles.icon}>
        <Image src={icon} alt={"Token logo"} width={40} height={40} />
      </div>
      <div className={styles.inputSection}>
        <span className={styles.placeholder}>{label}</span>
        <div className={styles.inputWrapper}>
          <NumericFormat
            getInputRef={ref}
            maxLength={maxLength}
            className={styles.ethAmount}
            value={value}
            decimalScale={maxDecimal}
            allowNegative={false}
            onChange={(e) => setValue(e.currentTarget.value)}
            placeholder="0"
            aria-labelledby="bless-label"
            aria-describedby="bless-description"
            {...numericFormatterProps}
          />
        </div>
      </div>
      {!hideMinMax && (
        <div className={styles.minMaxBtns}>
          <button onClick={(e) => minMaxBtnClick(e, handleMin)}>min</button>
          <button onClick={(e) => minMaxBtnClick(e, handleMax)}>max</button>
        </div>
      )}
    </div>
  );
};

export default DispenserInput;
